import type { AutosuggestProps } from '@risk-smart/themed-cloudscape-components/autosuggest';
import type { ControllerRenderProps } from 'react-hook-form';
import Autosuggest from 'src/components/form/autosuggest';
import { FormField } from 'src/components/form/form/FormField';
import type { Content } from 'src/components/help-panel/useHelpStore';
import type { IssueAssessmentFields } from 'src/pages/issues/update/forms/issue-assessment-form/issueAssessmentSchema';

export interface ResponsibleThirdPartyAutosuggestViewProps {
  disabled: boolean;
  errorText?: string;
  field: ControllerRenderProps<IssueAssessmentFields, 'ThirdPartyResponsible'>;
  guidance?: Content;
  label: string;
  options: AutosuggestProps.Options | undefined;
  placeholder?: string;
  statusType: AutosuggestProps['statusType'];
  testId?: string;
}

export const ResponsibleThirdPartyAutosuggestView = ({
  disabled,
  errorText,
  field: { ref, name, onBlur, onChange, value },
  guidance,
  label,
  options,
  placeholder,
  statusType,
  testId,
}: ResponsibleThirdPartyAutosuggestViewProps) => (
  <FormField
    label={label}
    testId={testId}
    errorText={errorText}
    stretch
    guidance={guidance}
  >
    <Autosuggest
      ref={ref}
      name={name}
      value={value ?? ''}
      onBlur={onBlur}
      onChange={(event) => onChange(event.detail.value)}
      options={options}
      statusType={statusType}
      enteredTextLabel={(enteredValue) => `Use: "${enteredValue}"`}
      ariaLabel={'Enter value'}
      placeholder={placeholder ?? 'Enter value'}
      empty={'No matches found'}
      disabled={disabled}
    />
  </FormField>
);
